import React, { useEffect, useState } from "react";
import { App } from "../commercial/main";
import axios from "../axios/AxiosInstance";
import { connectClients } from "../commercial/services/liveClients";
import { loadCommercialState, saveCommercialState } from "../services/commercialState";

export default function CommercialPage({ dayContent, headerActionsTarget }) {
  const user = {
    id: localStorage.getItem("userId"),
    name: [localStorage.getItem("firstname"), localStorage.getItem("lastname")].filter(value => value && value !== "undefined").join(" ") || "Mon espace",
    role: "commercial", agency: localStorage.getItem("agencyCity") || localStorage.getItem("agencyName") || "Mon agence",
  };
  const key = `jm-commercial-live:${user.id}:${localStorage.getItem("agencyName")}`;

  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  useEffect(() => {
    let active = true;
    Promise.all([axios.get("client/freelance"), loadCommercialState()]).then(([{data:clients}, saved]) => {
      if (!active) return;
      setData(connectClients(Array.isArray(clients) ? clients : [], user, saved));
    }).catch(() => { if (active) setError("Impossible de charger votre espace commercial. Actualisez la page pour réessayer."); });
    return () => { active = false; };
  // The page is remounted when changing agencies.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);
  return <><div className="commercial-module">
    {error ? <p role="alert" className="text-red-700">{error}</p> : !data ? <p>Chargement de vos clients…</p> : !data.clients.length ? <p>Aucun client disponible pour cette agence.</p> : <App headerActionsTarget={headerActionsTarget} key={key} initialData={data} persistenceKey={key} onPersist={saveCommercialState} currentUser={user} dayContent={dayContent} />}
  </div>
  </>;
}
